// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e11182fb","648":"5ffc70b6"}[chunkId] + ".chunk.js";
};